import { UtilityText } from '@policygenius/mortar';
import React from 'react';

import LegalSection from '../LegalSection';
import classes from './footer.module.scss';

const BBBSeal = 'https://static.policygenius.com/svgs/BBBSeal.svg';
const PgLogo = 'https://static.policygenius.com/svgs/PgLogo.svg';

const Footer = () => (
  <footer className={classes.footer}>
    <img className={classes.logo} src={PgLogo} alt="Policygenius" height="22" width="124" />
    <UtilityText className={classes.address} size="small">
      PO Box 758648
      <br />
      Topeka, KS 66675-8648
    </UtilityText>

    <a href="https://www.bbb.org/us/ny/new-york-city/profile/insurance-services-office/policygenius-inc-0121-147942">
      <img className={classes.BBBSeal} src={BBBSeal} alt="BBB Seal" />
    </a>
    <LegalSection />
  </footer>
);

export default Footer;
